export const FILE_EXTENSION = {
  CSV: 'csv',
  XLSX: 'xlsx',
} as const

export type FileExtension = typeof FILE_EXTENSION[keyof typeof FILE_EXTENSION]

export const EXCEL_EXPORT_OPTIONS = [
  {label: 'CSV', value: FILE_EXTENSION.CSV},
  {label: 'XLSX', value: FILE_EXTENSION.XLSX},
]
